import React, { useState } from "react";
import UploadIcon from "../../svgs/upload.svg";
import Button from "../../atoms/Button";
import { Form, Input, Upload } from "antd";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
import {
  FileAddOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { uploadDocument } from "../../../utils/API/uploadDocuments";
import { useDispatch } from "react-redux";

const allowedFileTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
];

const ComboField = ({ label, stateName, documents, setDocuments }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [uploadCLik, setUploadClik] = useState(false);

  const onUpload = async ({ file, onSuccess, onError }) => {
    if (documents[stateName].length == 1) {
      toast.error("Maximum 1 file can be uploaded");
      return;
    }

    const isAllowedType = allowedFileTypes.includes(file.type);
    if (!isAllowedType) {
      const fileExtensionsString = allowedFileTypes
        .map((fileType) => {
          const parts = fileType.split("/");
          return parts[1];
        })
        .join(", ");
      toast.error(`You can only upload ${fileExtensionsString} files!`);
      return;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      toast.error("File must be smaller than 2MB!");
      return;
    }

    try {
      setLoading(true);
      const response = await uploadDocument(
        file,
        stateName,
        documents[stateName].length + 1,
        1,
        dispatch
      );
      onSuccess();
      setDocuments((prev) => {
        const array = prev[stateName];
        array.push({ name: file.name, url: response.data, status: "done" });
        return {
          ...prev,
          [stateName]: array,
        };
      });
      setUploadClik(false)
      setLoading(false);
    } catch (error) {
      onError();
      setLoading(false);
      toast.error(error.message);
      console.error(error);
    }
  };

  const customValidator = (_, value) => {
    if (documents[stateName].length == 0) {
      return Promise.reject(new Error('Documet is required'));
    }
    return Promise.resolve();
  };
  const inputClass = "border-0 border-b-2 rounded-none";
  return (
    <div>
      <Form.Item
        label={label}
        className="font-normal mb-0"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        required
      >
        <div className="inline-block w-[80%]">
          <Form.Item
            name={stateName}
            rules={[
              {
                required: true,
                message: `Please enter ${label}`,
              },
              {
                validator: customValidator, // Custom validation rule
              },
            ]}
          >
            <Input className={inputClass} />
          </Form.Item>
        </div>
        <div className="inline-block float-right">
          <Form.Item>
            <Upload
              maxCount={1}
              showUploadList={false}
              customRequest={onUpload}
            >
              <Button
                varient={"primary"}
                color={"blue"}
                className={
                  "px-2 py-1 rounded-[5px] text-xs text-white font-medium flex justify-center gap-x-1 items-center"
                }
              >
                <img src={UploadIcon} alt="upload icon" className="w-3" />
                Upload
                {loading && <LoadingOutlined className="ml-2" />}
              </Button>
            </Upload>
          </Form.Item>
        </div>
      </Form.Item>
      {documents[stateName].length > 0 && (
        <div className="mb-4 border p-2 rounded-lg">
          {documents[stateName].map(({ name: fileName, url }, index) => (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
              className="group hover:bg-gray-100 px-2 py-1 flex justify-between items-center rounded-md"
              key={`${stateName}_${index}`}
            >
              <span>
                <FileAddOutlined className="mr-2" />
                <Link to={url} target="_blank" className="hover:text-blue-800">
                  {" "}
                  {fileName}
                </Link>
              </span>
              <DeleteOutlined
                className="hidden group-hover:block cursor-pointer hover:text-blue-800"
                onClick={() => {
                  const updatedArray = documents[stateName];
                  updatedArray.splice(index, 1);
                  setDocuments((prev) => {
                    return { ...prev, [stateName]: updatedArray };
                  });
                }}
              />
            </motion.div>
          ))}
        </div>) }
    </div>
  );
};

export default ComboField;
